<template>
  <section class="companies" :class="{ container: title && !noContainer, 'title-on-top': titleOnTop, 'no-fill': noFill }">
    <div class="trusted-companies">
      <div v-if="titleOnTop && title" class="title">
        {{ title }}
      </div>
      <div class="logos">
        <div v-if="!titleOnTop && title" class="title">
          {{ title }}
        </div>
        <div v-for="(company) in companies" :key="company.icon" class="logo">
          <component
            :is="icon(company.icon)"
            :class="company.icon"
          />
          <span v-if="company.text" class="text">
            {{ company.text }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    companies: { type: Array, default: () => ([]), required: true },
    titleOnTop: Boolean,
    noFill: Boolean,
    title: { type: String, default: 'Trusted by employees from:' },
    noContainer: Boolean,
  },
  methods: {
    icon(icon) {
      // eslint-disable-next-line import/no-dynamic-require
      return icon ? require(`../assets/svg/companies/logo-${icon}.svg?vue-component`) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.companies {
  padding-top: 0;
  padding-bottom: 0;

  &.title-on-top {
    .title {
      text-align: center;
      margin-bottom: 24px;
    }
  }

  &:not(.no-fill) .logos .logo svg {
    [fill] {
      fill: var(--main-light-shade-4);
    }

    [stroke] {
      stroke: var(--main-light-shade-4);
    }
  }
}

.trusted-companies {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: var(--spacing-44);
  color: var(--main-light-shade-4);
  font-size: 12px;

  .title {
    font-size: 18px;
    color: var(--main-light-shade-3);
  }

  .logos {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;

      svg {
        height: 28px;
        margin-right: 10px;
      }
    }
  }
}

@include bp($bp-laptop) {
  .trusted-companies .logos .logo svg {
    height: 21px;
  }
}

@include bp($bp-mobile) {
  .trusted-companies {
    display: block;
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 80px;

    .title {
      margin: var(--spacing-40) auto var(--spacing-40);
      width: 100%;
      flex: 0 0 100%;
      text-align: center;
    }

    .logos {
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 16px;
      column-gap: 40px;

      .logo svg {
        width: auto;
        height: 25px;
      }
    }
  }
}
</style>
